import {
  CARD_POSITION_INITIAL,
  CARD_POSITION_HIDDEN,
  CARD_POSITION_READ,
} from '../../components/CardAndHand';

export const getCardReaderZoomLevel = (screen) => {
  switch (screen) {
    case 'Home':
    case 'ValueTicketConfirmation':
    case 'ExtraTicketConfirmation':
    case 'SeasonalTicketConfirmation':
    case 'AdditionalZoneConfirmation':
      return 1;
    default:
      return 2;
  }
};

export const getCardPosition = (screen) => {
  switch (screen) {
    case 'Home':
      return CARD_POSITION_INITIAL;
    case 'ValueTicketConfirmation':
    case 'ExtraTicketConfirmation':
    case 'SeasonalTicketConfirmation':
    case 'AdditionalZoneConfirmation':
      return CARD_POSITION_READ;
    default:
      return CARD_POSITION_HIDDEN;
  }
};
